import { useRouter } from 'next/router';

export default function RedirectUrl({ sqlData = {} }: { sqlData: any }) {
    //const { redirectEndTime, redirectStartTime, redirectUrl } = sqlData;
    const redirectStartTime = sqlData?.redirectStartTime;
    const redirectEndTime = sqlData?.redirectEndTime;
    const redirectUrl = sqlData?.redirectUrl;
    if (!redirectStartTime || !redirectEndTime || !redirectUrl) {
        return null;
    }

    try {
        const dateStart = new Date(redirectStartTime);
        const dateEnd = new Date(redirectEndTime);
        const timeStart = dateStart.getTime();
        const timeEnd = dateEnd.getTime();
        const timeNow = Date.now();
        if (timeStart < timeNow && timeEnd > timeNow) {
            const router = useRouter();
            router.push(redirectUrl);
        }
    } catch (error) {}
    return null;
}
